import { AppAreaConfig } from '@/funnels/@types'

// Промо-креатив: `utm_term` вида <Concept><Author><Variant>, например
// `FoodNoiseClinicExpertCarterA1`. Автор (ExpertCarter) включает новый первый экран,
// буква — препарат, ровно как в DEV-35776.
//
// Оба условия висят на одном ключе `utm_term`, а матчер умеет только одно выражение на
// ключ — поэтому пара собрана в один regex через lookahead. Значение приходит уже
// в нижнем регистре (`checkSingleMatcher`), флаг `i` оставлен для читаемости.
const PROMO_TIRZEPATIDE = /(?=.*expertcarter)(?=.*a1)/i
const PROMO_SEMAGLUTIDE = /(?=.*expertcarter)(?=.*b1)/i
const PROMO_UNIVERSAL = /expertcarter/i

const appAreaConfig: AppAreaConfig = {
	appArea: 'glp-app',
	options: {
		userTags: ['glp'],
		// DEV-35776: препарат на этой области диктует вариант лендинга (ниже), а не ответ на
		// экране `medication-choice` — тот остаётся в данных для аналитики, но не двигает
		// пейвол. См. AppAreaOptions.
		medicationFromLanding: true,
	},
	landing: {
		// DEV-35776: вариант лендинга выбирает креатив — `utm_term` содержит A1 → тирзепатид,
		// B1 → семаглутид, ни того ни другого → универсальный (и дефолтный тирзепатид на
		// пейволе). Буквы креатива разбираются ТОЛЬКО здесь, а `medication` на оверрайде —
		// единственный мостик в словарь пейвола: LandingView кладёт его в location-стор,
		// `survey.effectiveMedicationChoice` читает оттуда. Поэтому лендинг и предпик
		// разойтись не могут, а `utm_term` нигде больше не парсится.
		//
		// Тирзепатид первым: матчер возвращает первое совпадение, так что term с обеими
		// буквами даёт тот же препарат, что и универсальный лендинг по умолчанию.
		//
		// `?medication=` здесь не участвует вообще: это CRM-сигнал, его читает только пейвол
		// (PaywallView.queryMedication), а рассылка ведёт сразу на plan-glp-dm через
		// /redirect (docs/crm-email-links.md), мимо лендинга.
		ids: ['glp-app-universal'],
		overrides: [
			// Промо-тройка идёт первой: её креативы несут и букву препарата, так что на
			// обычные строки они матчатся тоже. Внутри тройки универсальный вариант
			// последний по той же причине — `PROMO_UNIVERSAL` совпадает и с `…CarterA1`.
			{ ids: ['glp-app-tirzepatide-promo'], matcher: { utm_term: PROMO_TIRZEPATIDE }, medication: 'tirzepatide' },
			{ ids: ['glp-app-semaglutide-promo'], matcher: { utm_term: PROMO_SEMAGLUTIDE }, medication: 'semaglutide' },
			{ ids: ['glp-app-universal-promo'], matcher: { utm_term: PROMO_UNIVERSAL } },

			{ ids: ['glp-app-tirzepatide'], matcher: { utm_term: /a1/i }, medication: 'tirzepatide' },
			{ ids: ['glp-app-semaglutide'], matcher: { utm_term: /b1/i }, medication: 'semaglutide' },
		],
		route: {
			path: '/glp-app',
			name: 'glp-app-funnel',
		},
	},
	funnel: {
		id: 'ob-kova-glp-1-app-ds',
		route: {
			path: '/glp-app/ob/:page(.*)?',
			name: 'glp-app',
		},
		slug: 'glp-app',
		locale: ['en'],
	},
	paywall: {
		routeName: 'plan-glp-app',
	},
}

export default appAreaConfig
